(function(){
  if(window.__fenloColorJourney)return;
  window.__fenloColorJourney=true;
  var key='fenlo:color:landing:v1';
  var paths=['/products/fantasy-color','/products/fantasy-plus-color','/products/fantasy-edge-color'];
  var home=location.pathname==='/',pdp=Boolean(document.querySelector('[data-color-pdp]'));
  var maxAge=12*60*60*1000;
  function read(){
    try{
      var state=JSON.parse(sessionStorage.getItem(key)||'null');
      if(!state||state.v!==1||!Number.isFinite(state.y)||state.y<0||!Number.isFinite(state.at)||Date.now()-state.at>maxAge||Date.now()<state.at)return null;
      if(typeof state.anchor!=='string'||!/^fc-[a-z0-9-]{1,70}$/.test(state.anchor))state.anchor='';
      if(!Number.isFinite(state.offset))state.offset=0;
      return state;
    }catch(error){return null;}
  }
  function save(){
    var y=Math.max(0,window.scrollY),anchor='',offset=0,best=-Infinity;
    document.querySelectorAll('.fc-page section[id],.fc-page .fc-model-card[id]').forEach(function(node){
      if(!/^fc-[a-z0-9-]{1,70}$/.test(node.id))return;
      var rect=node.getBoundingClientRect(),top=rect.top+y;
      if(rect.height>0&&top<=y+1&&top>best){best=top;anchor=node.id;offset=y-top;}
    });
    try{sessionStorage.setItem(key,JSON.stringify({v:1,at:Date.now(),y:y,anchor:anchor,offset:offset}));}catch(error){}
  }
  function address(link){try{return new URL(link.href,location.href);}catch(error){return null;}}
  function returnLink(link){
    var url=address(link);
    if(!url||url.origin!==location.origin||url.pathname!=='/'||url.hash)return;
    if(read()){url.searchParams.set('fc_return','1');url.hash='fc-return';link.setAttribute('href',url.pathname+url.search+url.hash);}
  }
  if(pdp)document.querySelectorAll('a[href]').forEach(returnLink);
  document.addEventListener('click',function(event){
    var link=event.target.closest&&event.target.closest('a[href]');
    if(!link)return;
    var url=address(link);
    if(!url||url.origin!==location.origin)return;
    if(home&&paths.indexOf(url.pathname.replace(/\/$/,''))!==-1)save();
    if(pdp&&url.pathname==='/'&&!url.hash)returnLink(link);
  },true);
  var stop=null;
  function restore(){
    var url=new URL(location.href);
    if(!home||url.searchParams.get('fc_return')!=='1'||url.hash!=='#fc-return')return;
    url.searchParams.delete('fc_return');url.hash='';
    try{history.replaceState(history.state,'',url.pathname+url.search);}catch(error){}
    var state=read();if(!state)return;
    if(stop)stop();
    var active=true,frame=0,observer=null;
    var previous=history.scrollRestoration;
    try{history.scrollRestoration='manual';}catch(error){}
    function correct(){
      frame=0;if(!active)return;
      var anchor=state.anchor&&document.getElementById(state.anchor);
      var y=anchor?anchor.getBoundingClientRect().top+window.scrollY+state.offset:state.y;
      window.scrollTo({top:Math.max(0,y),left:0,behavior:'instant'});
    }
    function schedule(){if(active&&!frame)frame=requestAnimationFrame(correct);}
    function finish(){
      if(!active)return;active=false;
      if(frame)cancelAnimationFrame(frame);
      if(observer)observer.disconnect();
      clearTimeout(timeout);
      ['wheel','touchstart','pointerdown'].forEach(function(name){window.removeEventListener(name,finish,true);});
      window.removeEventListener('keydown',keyCancel,true);
      window.removeEventListener('load',schedule);
      try{history.scrollRestoration=previous;}catch(error){}
    }
    function keyCancel(event){if(['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].indexOf(event.key)!==-1)finish();}
    stop=finish;
    ['wheel','touchstart','pointerdown'].forEach(function(name){window.addEventListener(name,finish,{capture:true,passive:true});});
    window.addEventListener('keydown',keyCancel,true);
    window.addEventListener('load',schedule,{once:true});
    if(window.ResizeObserver){observer=new ResizeObserver(schedule);observer.observe(document.querySelector('.fc-page')||document.body);}
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
    var timeout=setTimeout(finish,2000);
    correct();schedule();
  }
  restore();
  window.addEventListener('pageshow',function(event){if(event.persisted)restore();});
  window.addEventListener('pagehide',function(){if(stop)stop();});
})();
